<template>
  <apps-integration
    :app="app"
    :qr-code-url="qrCodeUrl"
    :account="accountId"
    :env="env"
    :is-initializing="isInitializing"
    :is-updating="isUpdating"
    :is-activating="isActivating"
    @create="createOneReachApp({ app: $event })"
    @update="updateOneReachApp({ app: $event })"
    @qr-code-click="openQRCodeURL"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';

import AppsIntegration from '../components/AppsIntegration.vue';
import { useAppsIntegration } from '../composables';
import { useAppLauncher } from '../../../composables';
import { useOneReachConfig, useAuth } from '@/composables';

/** TODO: We might want to provide settings and token as props? */
export default defineComponent({
  name: 'AppsIntegrationContainer',
  components: { AppsIntegration },
  setup() {
    const { settingsInDB } = useAppLauncher();
    const { getORConfig } = useOneReachConfig();
    const { accountId, getToken } = useAuth();
    const {
      app,
      qrCodeUrl,
      isInitializing,
      isUpdating,
      isActivating,
      initializeAppsIntegration,
      openQRCodeURL,
      createOneReachApp,
      updateOneReachApp,
    } = useAppsIntegration({ settings: settingsInDB, getToken: () => getToken() });

    initializeAppsIntegration();
    return {
      app,
      qrCodeUrl,
      accountId,
      env: getORConfig().ENVIRONMENT,
      isInitializing,
      isUpdating,
      isActivating,
      openQRCodeURL,
      createOneReachApp,
      updateOneReachApp,
    };
  },
});
</script>
